import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A `}<a parentName="p" {...{
        "href": "https://www.deckset.com/"
      }}>{`Deckset`}</a>{` theme of the GitHub presentation template is available for download for the members of the GitHub organization on `}<a parentName="p" {...{
        "href": "https://drive.google.com/open?id=1PDKiK_hOJja6ZBQiTHy37JD8S4Buzwz7"
      }}>{`Google Drive`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/77022093-e8f12880-6945-11ea-92f9-623556fa6488.png",
        "alt": "deckset-template"
      }}></img></p>
    <p>{`An example presentation is also provided to showcase various slide options when using the theme but please refer to the official `}<a parentName="p" {...{
        "href": "https://docs.decksetapp.com/English.lproj/getting-started.html"
      }}>{`Deckset help site`}</a>{` for more detailed information.`}</p>
    <h3>{`How to use`}</h3>
    <ol>
      <li parentName="ol">{`Download the assets`}</li>
      <li parentName="ol">{`Open Deckset and click `}<strong parentName="li">{`File > Import Theme...`}</strong></li>
      <li parentName="ol">{`Navigate to the `}<inlineCode parentName="li">{`GitHub Presentation Template - Deckset`}</inlineCode>{` folder and select `}<inlineCode parentName="li">{`GitHub_Theme.dstheme`}</inlineCode></li>
      <li parentName="ol">{`Create your markdown presentation in Deckset! 🎉`}</li>
    </ol>
    <h4>{`Basic customization`}</h4>
    <p>{`Here is a basic set of commands that you can add to individual slides to customize your content:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Command`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`[.background-color: #HEXVALUE]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Changes the background color for an individual slide`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`[.hide-footer]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Hides the footer for an individual slide`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`[.slidenumbers:true/false]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Shows or hides the slide numbers for an individual slide.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`[.code-highlight: LINE NUMBERS]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Step through highlighted lines of code.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Learn more about customizing your slides on the `}<a parentName="p" {...{
        "href": "https://docs.decksetapp.com/English.lproj/getting-started.html"
      }}>{`Deckset help site`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p>{`😕 `}<strong parentName="p">{`Having trouble?`}</strong>{` Message us in `}<a parentName="p" {...{
          "href": "https://github.slack.com/messages/C0ZCGGGJ2"
        }}>{`#design-systems`}</a>{` for assistance.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      